import { BusinessUnitItemComponentBase } from './business-unit-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-item',
  templateUrl: './business-unit-item.component.html',
  styleUrls: ['./business-unit-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class BusinessUnitItemComponent extends BusinessUnitItemComponentBase {

  constructor(protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(businessUnitService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.typeLoadSelectionList();
  }
    
  itemSet() {
    super.itemSet();
  }
  
}





